import React from 'react'
import { Link } from 'gatsby'

export default function Path ({ category, page }) {
  return (
    <div className='pathCss'>
      <Link to='/'>
        <p className='back-link'>All</p>
      </Link>
      <p> / </p>
      <Link to={`/category/${category}`}>
        <p className='back-link'>{category?.charAt(0).toUpperCase() + category?.slice(1)}</p>
      </Link>
      <p> / </p>
      <Link to={`/category/${category}/${page !== 1
          ? page
          : ''}
        `}
      >
        <p className='back-link'>{page}</p>
      </Link>
    </div>
  )
}
